/**
 * The unit an auction tournament's prices are in. A label only: prices, purses and steps are
 * whole numbers whatever it is, and nothing is converted when it changes. The database holds the
 * same four codes in a check on `tournaments.auction_currency`. See 20261012000400.
 */
export const AUCTION_CURRENCIES = [
  { code: "Cr", name: "Crore", prefix: false },
  { code: "L", name: "Lakh", prefix: false },
  { code: "₹", name: "Rupee", prefix: true },
  { code: "pts", name: "Points", prefix: false },
] as const;

export type AuctionCurrency = (typeof AUCTION_CURRENCIES)[number]["code"];

export const DEFAULT_AUCTION_CURRENCY: AuctionCurrency = "Cr";

/** A price with its currency: "45 Cr", "₹45". */
export function formatPrice(amount: number, currency: AuctionCurrency): string {
  const found = AUCTION_CURRENCIES.find((c) => c.code === currency);
  return found?.prefix ? `${currency}${amount}` : `${amount} ${currency}`;
}
